var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('v-btn',{attrs:{"text":"","color":_vm.color},on:{"click":function($event){_vm.open = false}}},[_vm._v("OK")])]},proxy:true}]),model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }